import { useAtom } from '@reatom/react'
import { ProposalFilesView } from './proposal-files-view'
import { orderFilesAtom, orderFilesLoadingAtom } from './order-files.atom'


export function OrderFilesModalContent() {
  const [
    { attachedFilesMap },
    { uploadFiles, deleteFile },
  ] = useAtom(orderFilesAtom)
  const [isLoading] = useAtom(orderFilesLoadingAtom)

  return (
    <ProposalFilesView
      proposalFiles={[...attachedFilesMap.values()]}
      isLoading={isLoading}
      onAttachFiles={uploadFiles}
      onRemoveFile={deleteFile}
      canEdit={true}
    />
  )
}
